export default {
  props: ['appScope', 'row', 'value', 'index']
}
